import { Divider } from "@/components/misc";
import { useState, useEffect } from "react";
import { CardDropdownProject } from "./Utils/CardDropdown";
import { CardBase } from "./Utils/CardHelper";
import { ProjectProgress } from "../ProjectProgress/MainContainer";
import { NotesSection } from "../ProjectProgress/Utils/NotesSection";
import { TitleHeaderHyperlink } from "./Utils/TitleHeaderHyperlink";
import { ProjectProps } from "@/interfaces/project_types";

type ProjectCardProps = {
    project: ProjectProps,
    isNew: boolean,
    isMini: boolean,
    onView: () => void
}
export function ProjectCard({ project, isNew, isMini, onView }: ProjectCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView]);

    return (
        <CardBase
            isNew={isMini ? false : true}
            hoverInsteadOfClick={isMini ? false : true}
            hoverChildren={<CardDropdownProject
                edit_project_route={`/projects/update_project/${project.project_id}`}
                create_task_route={`/tasks/create_task_from_project/${project.project_id}`}
                assign_tasks_route={`/tasks/assign_tasks/${project.project_id}`}
                folder_path={`${project.folder_location}`}
                create_rfi_route={`/rfi/create_rfi_from_project/${project.project_id}`}
                create_submittal_route={`/submittals/create_submittal_from_project/${project.project_id}`} />}
        >
            {isMini ? <MiniProjectCard project={project} /> : <DefaultProjectCard project={project} />}
        </CardBase>
    );
}

function MiniProjectCard({ project }: { project: ProjectProps }) {
    return (
        <TitleHeaderHyperlink title={project.project_name} folder_location={project.folder_location ?? ''} />
    )
}

function DefaultProjectCard({ project }: { project: ProjectProps }) {
    return (
        <>
            <TitleHeaderHyperlink title={project.project_name} folder_location={project.folder_location ?? ''} />

            <Divider />

            <NotesSection notes={project.description ?? ''} />

            <div className="flex flex-row justify-between items-center">
                <ProjectProgress project={project} />
            </div>
            <p className="text-right text-sm">{project.end_date ? `Next Deadline: ${project.end_date}` : 'No Date Due'}</p>

        </>
    )
}